module.exports = {"DIALOG_CONFIRMATION_TITLE":"Konfirmasi","DIALOG_CONFIRM_CANCEL_LABEL":"Batal","DIALOG_CONFIRM_ACCEPT_LABEL":"Terima"}